import { render, staticRenderFns } from "./LeaderboardUserElement.vue?vue&type=template&id=363087aa&scoped=true"
import script from "./LeaderboardUserElement.vue?vue&type=script&lang=js"
export * from "./LeaderboardUserElement.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardUserElement.vue?vue&type=style&index=0&id=363087aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363087aa",
  null
  
)

export default component.exports